(function() {
	'use strict';

	angular
		.module('app.leanProjects')
		.controller('xMatrix', xMatrix);

	xMatrix.$inject = ['$rootScope', '$scope', '$filter', '$timeout', '$compile',
		'$uibModal', '$translate', 'X_MATRIX', 'xMatrixService', 'a3ModalService', 'pageTimingService', 'dashboardFilterInitializationService', 'leanFilterService',
		'tableService'];

	function xMatrix($rootScope, $scope, $filter, $timeout, $compile,
			$uibModal, $translate, X_MATRIX, xMatrixService, a3ModalService, pageTimingService, dashboardFilterInitializationService, leanFilterService,
			tableService) {
		/*jshint validthis: true */
		var vm = this;
		vm.hasProjects = true;
		vm.noDataMessage = X_MATRIX.noDataMessage;
		$scope.filterService = dashboardFilterInitializationService;
		$scope.leanFilterService = leanFilterService;
		var type;
		var area;
		var plantNdx;
		var metricDateRange;
		$scope.slideshowView = $rootScope.slideshowView;

		function activate() {
			reset();
			getData();
			setup();
		}

		function reset() {
			vm.hasProjects = true;
			vm.projects = '';
			vm.metrics = '';
			vm.goals = '';
		}

		function getData() {
			xMatrixService.getFactoryMetricDateRange().then(function(data) {
				metricDateRange = data;
			});

			xMatrixService.getUndefinedValueStream().then(function(data) {
				angular.forEach(data.undefinedValueStream, function (valueStream) {
					plantNdx = valueStream.ndx;
				});
			});

			xMatrixService.getProjects().then(function(data) {
				vm.projectsData = data;
				if (!vm.projectsData || !vm.projectsData['projects'] || !vm.projectsData['projects'].length) {
					vm.hasProjects = false;
				} else {
					vm.projects = vm.projectsData['projects'];
				}
			});

			xMatrixService.getMetrics().then(function(data) {
				vm.metrics = data;
			});

			xMatrixService.getGoals().then(function(data) {
				vm.goals = data;
			});

			tableService.trackPageView('x-matrix', $scope.leanFilterService.getFactoryList());
		}

		function setup() {
			if (vm.projects === '' || vm.metrics === '' ||
				vm.goals === '') {
				$timeout(function() {
					setup();
				}, 10);
			} else {
				if (vm.hasProjects) {
					tableGenerator();
					jQuery('table').rotateTable();
					cleanup();
				}
				$rootScope.title = 'LeanDNA Dashboard - X Matrix';
				var columnDefinition = $scope.$parent.$parent.col;
				var curWidget = $scope.$parent.model;
				if (!$scope.slideshowView) {
					pageTimingService.markWidgetDoneLoading('column' + columnDefinition.columnIndex, columnDefinition.widgets.indexOf(curWidget));
				}
			}
		}

		function showErrorToast(message) {
			$rootScope.$emit('toast', {
				message: message,
				success: false
			});
		}

		function filterResults() {
			if (vm.projects.length > 25) {
				var totalProjects = vm.projects.length - 1;
				vm.projects = _.slice(vm.projects, 0, 25);
				vm.projects = _.reduce(vm.projects, function (map, obj) {
					map[obj.ndx] = obj;
					return map;
				}, {});
				var projectIds = _.keys(vm.projects);
				var projectManagers = {};
				var goalNdxs = [];
				var metricNdxs = [];
				var limitedProjects = _.filter(vm.projects, function (project, key) {
					if (key === 'projectManagers' || _.indexOf(projectIds, project.ndx.toString()) == -1) {
						return false;
					}
					var gNdxs = _.get(project, 'goalNdxs', '');
					var mNdxs = _.get(project, 'metricNdxs', '');
					if (gNdxs !== '') {
						goalNdxs = _.concat(goalNdxs, gNdxs.split(','));
					}
					if (mNdxs !== '') {
						metricNdxs = _.concat(metricNdxs, mNdxs.split(','));
					}
					projectManagers[project.projectManagerNdx] = {'ndx': project.projectManagerNdx, 'name': project.projectManagerName};
					return true;
				});

				goalNdxs = _.uniq(goalNdxs);
				metricNdxs = _.uniq(metricNdxs);

				vm.goals = _.omitBy(vm.goals, function(value, key) {
					return _.indexOf(goalNdxs, key.toString()) === -1;
				});

				vm.metrics = _.filter(vm.metrics, function(metric, key) {
					return _.indexOf(metricNdxs, key.toString()) >= 0;
				});
				
				showErrorToast('Showing 25 of ' + totalProjects + ' projects. Please refine your filters.');
				vm.projects = _.sortBy(_.values(limitedProjects), 'name');
			}
		}

		function tableGenerator() {
			var fullMetricNdxs = [];
			var fullMetricWorkCenterNdxs = [];
			var fullMetricNames = [];

			var fullMemberNdxs = [];
			var fullMemberNames = [];

			var fullGoalNdxs = [];
			var fullGoalNames = [];
			var table = jQuery('.matrix-table');
			table.empty();

			var targetSavings = 0;
			var actualSavings = 0;
			var savingsByCategory = vm.projectsData['projectsSavingsTotal'];

			if (savingsByCategory) {
				savingsByCategory = _.orderBy(savingsByCategory, ['includeInTotal'], ['desc']);
			}

			filterResults();

			vm.metrics = _.orderBy(vm.metrics, 'name', 'desc');
			_.forEach(vm.metrics, function(value, key) {
				fullMetricNdxs.push(_.get(value, 'ndx'));
				fullMetricWorkCenterNdxs.push(_.get(value, 'wNdx'));
				fullMetricNames.push(_.get(value, 'name'));
			});

			vm.projectsData['projectManagers'] = _.orderBy(vm.projectsData['projectManagers'], 'name', 'desc');
			_.forEach(vm.projectsData['projectManagers'], function(value, key) {
				fullMemberNdxs.push(value.ndx);
				fullMemberNames.push(value.name);
			});

			var goals = [];
			_.forEach(vm.goals, function (value, key) {
				goals.push({ 'ndx': key, 'name': value });
			});

			_.forEach(_.orderBy(goals, 'name'), function(goal) {
				fullGoalNdxs.push(goal.ndx);
				fullGoalNames.push(goal.name);
			});

			var rightColCount = fullMetricNdxs.length + fullMemberNdxs.length;
			var colGroupHtml = '';

			for (var i = 0; i < fullGoalNdxs.length; i++) {
				colGroupHtml += '<colgroup class="intersection"></colgroup>';
			}
			colGroupHtml += '<colgroup class="project-name-colgroup"></colgroup>';
			for (var i = 0; i < rightColCount; i++) {
				colGroupHtml += '<colgroup class="intersection"></colgroup>';
			}
			table.append(colGroupHtml);
			var factoryCurrencySymbol = globalConfig.user.authFacts[$scope.leanFilterService.getFactoryList()].currencySymbol;

			_.forEach(vm.projects, function(value) {
				var rowHtml = '';

				// Meta Info
				var projectNdx = _.get(value, 'ndx');
				var factoryNdx = _.get(value, 'factoryNdx');
				var projectName = strip(_.get(value, 'name'));
				var projectManager = _.get(value, 'projectManagerNdx');
				var colorStateType = getColorFromStateType(_.get(value, 'colorStateType'));
				var validateInitiativeFlag = _.get(value, 'validateInitiativeFlag') === 1;

				// Savings
				targetSavings += parseFloat(_.get(value, 'targetSavings'));
				actualSavings += parseFloat(_.get(value, 'actualSavings'));
				
				rowHtml += ('<tr>');

				var goalNdxs = _.get(value, 'goalNdxs', '');
				if (!goalNdxs && fullGoalNdxs.length != 0) {
					rowHtml += insertEmptyCells(fullGoalNdxs.length, false);
				} else {
					goalNdxs = goalNdxs.split(',');
					for (var i = 0; i < fullGoalNdxs.length; i++) {
						if (_.includes(goalNdxs, fullGoalNdxs[i].toString())) {
							rowHtml += ('<td class="intersection"><div class="circleDisplay colorBlack" title="' +
								_.escape(projectName) + ' - ' + _.escape(fullGoalNames[i]) + '"></div></td>');
						} else {
							rowHtml += ('<td class="intersection"></td>');
						}
					}
				}

				rowHtml += ("<td title='" + _.escape(projectName) + "' ng-click='xMatrixCtrl.openA3Popup(" + projectNdx + ',' + factoryNdx + ")'" +
					"class='project-name-cell colorTD pad5 hoverText'><div class='project-name' style='display:block;'>" +
					projectName + '</div></td>');

				var metricNdxs = _.get(value, 'metricNdxs', '');
				if (!metricNdxs && fullMetricNdxs.length != 0) {
					rowHtml += insertEmptyCells(fullMetricNdxs.length, true);
				} else {
					metricNdxs = metricNdxs.split(',');
					for (var i = 0; i < fullMetricNdxs.length; i++) {
						if (_.includes(metricNdxs, fullMetricNdxs[i].toString())) {
							rowHtml += ('<td class="intersection"><div class="circleDisplay colorBlack" title="' +
								_.escape(projectName) + ' - ' + _.escape(fullMetricNames[i]) + '"></div></td>');
						} else {
							rowHtml += ('<td class="intersection"></td>');
						}
					}
				}

				for (var i = 0; i < fullMemberNdxs.length; i++) {
					if (projectManager === fullMemberNdxs[i]) {
						if (validateInitiativeFlag) {
							rowHtml += ('<td class="intersection textCenter"><div class="fa-stack circleDisplay">' +
								'<i class="fa fa-circle fa-stack-1x colorBlueChecked"></i><i class="fa fa-check fa-stack-1x member-check"></i></div></div></td>');
						} else {
							rowHtml += ('<td class="intersection textCenter"><div class="circleDisplay color' +
								colorStateType + '" title="' + _.escape(projectName) + ' - ' + _.escape(fullMemberNames[i]) + '"></div></td>');
						}
					} else {
						rowHtml += ('<td class="intersection"></td>');
					}
				}

				rowHtml += ('</tr>');
				rowHtml = $compile(rowHtml)($scope);
				table.append(rowHtml);
			});

			// Middle Row START
			var rowHtml = '';
			rowHtml += '<tr>';
			for (var i = 0; i < fullGoalNames.length; i++) {
				var goal = _.escape(fullGoalNames[i]);
				rowHtml += '<td title="' + goal + '" class="goal-name-cell verticalOpp colorTD" align="center"><div class="divVerticalOpp"><div class="goal-name">' + goal + '</div></div></td>';
			}

			rowHtml += '<td class="middle-x">' +
				'<div class="middle-x-div">' +
				'<div class="projects-title">' + $translate.instant('PROJECTS') + '</div>' +
				'<div class="metrics-title">' + $translate.instant('METRICS') + '</div>' +
				'<div class="goals-title">' + $translate.instant('STRATEGIC GOALS') + '</div>' +
				'<div class="savings-title">' + $translate.instant('SAVINGS') + '</div>' +
				'</div>' +
				'</td>';

			for (var i = 0; i < fullMetricNames.length; i++) {
				rowHtml += '<td class="metric-name-cell vertical hoverText" style="cursor:pointer;" align="center" ng-click="xMatrixCtrl.openA3Modal(' +
					fullMetricNdxs[i] + ', \'' + _.escape(_.replace(fullMetricNames[i], /'/g, "\\'")) + '\', ' + fullMetricWorkCenterNdxs[i] +
					')"><div class="divVertical"><div class="metric-name spanPadding"> ' + fullMetricNames[i] + ' </div></div></td>';
			}

			rowHtml +=
				'<td class="member-table-cell" colspan="' + fullMemberNdxs.length + '">' +
				'<table id="memberTable" class="member-table">' +
				'<tr>' +
				'<td class="member-table-header" colspan="' + fullMemberNdxs.length + '">' + $translate.instant('Managers Responsible') + '</td>' +
				'</tr>' +
				'<tr>';

			for (var i = 0; i < fullMemberNames.length; i++) {
				rowHtml += '<td class="member-name-cell vertical" align="center"><div class="divVertical"><div class="member-name">' + fullMemberNames[i] + '</div></div></td>';
			}

			rowHtml += '</tr></table></td></tr>';
			rowHtml = $compile(rowHtml)($scope);
			table.append(rowHtml);

			// Middle Row END
			// Savings START
			rowHtml = '';
			rowHtml += '<tr>';
			if (fullGoalNdxs.length > 0) {
				rowHtml += '<td style="border:none !important;" colspan="' + fullGoalNdxs.length + '"></td>';
			}
			rowHtml += '<td class="savings-cell" style="text-align:center !important;">';
			rowHtml += $translate.instant('Target Savings Annual') + ': ' + $filter('currency')(targetSavings, factoryCurrencySymbol, 0) + '&nbsp;&nbsp;&nbsp;<span style="font-weight:bold;">';
			rowHtml += $translate.instant('Actual') + ': ' + $filter('currency')(actualSavings, factoryCurrencySymbol, 0);
			rowHtml += '</span></td>';
			if (fullMetricNdxs.length > 0) {
				rowHtml += '<td style="border:none !important;" colspan="' + fullMetricNdxs.length + '"></td>';
			}
			if (fullMemberNdxs.length > 0) {
				rowHtml += '<td style="border:none !important;" colspan="' + fullMemberNdxs.length + '"></td>';
			}
			rowHtml += '</tr>';
			rowHtml = $compile(rowHtml)($scope);
			table.append(rowHtml);
			// Savings END
			if (savingsByCategory && savingsByCategory.length) {
				angular.forEach(savingsByCategory, function (savingCategory) {
					// Savings By Category START
					var savingsCategoryName = _.escape(savingCategory['categoryName']);
					var cellClass = savingCategory['includeInTotal'] === 0 ? 'excluded-savings-cell' : 'savings-cell';
					var tooltipText = $translate.instant('This category is not included in savings & spend totals');
					var tooltip = savingCategory['includeInTotal'] === 0 ? 'title=\'' + tooltipText + '\'' : '';
					if (savingCategory['includeInTotal']) {

					}
					rowHtml = '';
					rowHtml += '<tr>';
					if (fullGoalNdxs.length > 0) {
						rowHtml += '<td style="border:none !important;" colspan="' + fullGoalNdxs.length + '"></td>';
					}
					rowHtml += '<td class="' + cellClass + '" style="text-align:center !important;" ' + tooltip + '>';
					if (savingCategory['status'] === 'Archive') {
						rowHtml += '<i>';
					}
					rowHtml += savingsCategoryName;
					if (savingCategory['status'] === 'Archive') {
						rowHtml += '</i>';
					}
					rowHtml += ' ' + $translate.instant('Target') + ': ' + $filter('currency')(savingCategory['targetSavingsValue'], factoryCurrencySymbol, 0) + '&nbsp;&nbsp;&nbsp;<span style="font-weight:bold;">';
					rowHtml += $translate.instant('Actual') + ': ';
					
					rowHtml += $filter('currency')(savingCategory['actualSavingsValue'], factoryCurrencySymbol, 0);
					rowHtml += '</span></td>';
					if (fullMetricNdxs.length > 0) {
						rowHtml += '<td style="border:none !important;" colspan="' + fullMetricNdxs.length + '"></td>';
					}
					if (fullMemberNdxs.length > 0) {
						rowHtml += '<td style="border:none !important;" colspan="' + fullMemberNdxs.length + '"></td>';
					}
					rowHtml += '</tr>';
					rowHtml = $compile(rowHtml)($scope);
					table.append(rowHtml);
					// Savings By Category END
				});
			}
		}

		jQuery.fn.rotateTable = function(options) {
			var cssClass = ((options) ? options.className : false) || 'verticalCell';

			var cellsToRotate = jQuery('.' + cssClass, this);

			var betterCells = [];
			var tHeight = null;
			cellsToRotate.each(function() {
				var cell = jQuery(this),
					newText = cell.text(),
					height = cell.height(),
					width = cell.width(),
					newDiv = jQuery('<div>', {
						height: width,
						width: 20
					}),
					newInnerDiv = jQuery('<div>', {
						text: newText,
						'class': 'rotated'
					});

				newDiv.append(newInnerDiv);
				betterCells.push(newDiv);
			});

			cellsToRotate.each(function(i) {
				jQuery(this).html(betterCells[i]);
			});

			cssClass = ((options) ? options.className : false) || 'verticalCellOpp';

			cellsToRotate = jQuery('.' + cssClass, this);

			betterCells = [];
			cellsToRotate.each(function() {
				var cell = jQuery(this),
					newText = cell.text(),
					height = cell.height(),
					width = cell.width(),
					newDiv = jQuery('<div>', {
						height: width,
						width: 20
					}),
					newInnerDiv = '';
				newInnerDiv = jQuery('<div>', {
					text: newText,
					'class': 'rotatedOpp'
				});
				newDiv.append("<span class='rotatedOpp'>" + newText + '</span>');
				betterCells.push(newDiv);
			});

			cellsToRotate.each(function(i) {
				jQuery(this).html(betterCells[i]);
			});
		};

		function cleanup() {
			// Adjust widths and heights of table
			var colGroups = jQuery('colgroup.intersection');
			var intersections = jQuery('td.intersection');
			if (colGroups.length < 4) {
				jQuery('.matrix-table').outerWidth(40 + '%');
				jQuery('.project-name-cell').outerWidth(80 + '%');
				var cellWidth = 20 / (colGroups.length);
				intersections.outerWidth(cellWidth + '%');
			} else if (colGroups.length < 7) {
				jQuery('.matrix-table').outerWidth(40 + '%');
				jQuery('.project-name-cell').outerWidth(50 + '%');
				var cellWidth = 50 / (colGroups.length);
				intersections.outerWidth(cellWidth + '%');
			} else {
				jQuery('.matrix-table').outerWidth(70 + '%');
				jQuery('.project-name-cell').outerWidth(40 + '%');
				var cellWidth = 60 / (colGroups.length);
				intersections.outerWidth(cellWidth + '%');
			}

			jQuery('.goal-name').width(300 - 30);
			jQuery('.metric-name').width(300 - 30);
			jQuery('.member-name').width(300 - 67);
			jQuery('.member-table').height(300);
			jQuery('.middle-x').height(300 + 4);

			jQuery('.slideshow-title').text('X-Matrix for ' + jQuery('.matrix-name').text());
		}

		function insertEmptyCells(length, flag) {
			var data = '';

			for (var i = 0; i < length; i++) {
				data += '<td class="intersection"></td>';
			}
			return data;
		}

		function getColorFromStateType(stateType) {
			switch (stateType) {
			case '10-good':
				return 'Green';
			case '20-warn':
				return 'Yellow';
			case '30-bad':
				return 'Red';
			default:
				return '';
			}
		}

		updateEventBind($scope, ['sideBarUpdate', 'slideshowViewChanged']);

		var listener = $rootScope.$on('xMatrixFilterChanged', function() {
			activate();
		});
		$scope.$on('$destroy', listener);

		vm.openA3Popup = function(projectNdx, factoryNdx) {
			var modalInstance = a3ModalService.openModal(projectNdx, factoryNdx);
			
			modalInstance.result.finally(function() {
				a3ModalService.removeNoPrintClass();
			});			
		};

		vm.openA3Modal = function(metricNdx, metricName, workcenterNdx) {
			if (workcenterNdx == 0) {
				workcenterNdx = plantNdx;
			} else {
				workcenterNdx = '';
			}
			var reportScope = $scope.$new();
			reportScope.isEmbedded = true;
			incomingData.metricNdx = metricNdx;
			incomingData.vsNdx = workcenterNdx;
			incomingData.metricName = metricName;
			incomingData.beginDate = metricDateRange.startDate;
			incomingData.endDate = metricDateRange.endDate;
			incomingData.factory = $scope.leanFilterService.getFactoryList();
			reportScope.mtrcName = metricName;

			var instance = $uibModal.open({
				scope: reportScope,
				templateUrl: '/application/f/dashboard/widgets/a3metric.html',
				windowTemplateUrl: '/application/f/dashboard/widgets/a3metric-template.html'
			});

			instance.result.then(function() {
				//do nothing on success
			}, function() {
				reportScope.closeDialog();
			});

			reportScope.closeDialog = function() {
				incomingData = {};
				instance.close();
				reportScope.$destroy();

			};
		};

		function init() {
			var canLoad = true;
			for (var key in $scope.filterService.updating) {
				if ($scope.filterService.updating[key]) {
					canLoad = false;
					break;
				}
			}
			if (canLoad) {
				activate();
				var columnDefinition = $scope.$parent.$parent.col;
				var curWidget = $scope.$parent.model;
				if (!$scope.slideshowView) {
					dashboardFilterInitializationService.markWidgetCreated('column' + columnDefinition.columnIndex, columnDefinition.widgets.indexOf(curWidget));
				}
			} else {
				$timeout(function () {
					init();
				}, 10);
			}
		}
		init();
	}
})();
